import { Button } from '@/components/common/Button';
import { Card } from '@/components/dashboard/DashboardCard';
import type { Order } from '@/domain/Order';
import { Role } from '@/domain/Role';
import { useHasRole } from '@/hooks/useHasRole';
import { OrderSupplementsTable } from '../orders/OrderSupplementsTable';
import { OrderUserInfoCard } from '../orders/OrderUserInfoCard';

export default function UserCard({ order }: { order: Order }) {
  const { hasRole } = useHasRole();
  const showLotNumbers = hasRole(
    Role.PACKER,
    Role.SHOP_ADMIN,
    Role.SUPERADMIN,
    Role.SALES_MANAGER,
  );

  return (
    <div className="flex flex-col gap-6">
      <Card className="bg-form-linear max-w-[640px] rounded-xl border-2 border-transparent p-6">
        <OrderUserInfoCard order={order} showLotNumber={showLotNumbers} />
        <OrderSupplementsTable order={order} showLotNumbers={showLotNumbers} />
      </Card>
      {hasRole(Role.DOCTOR) &&
        (order.parcel_track ? (
          <Button asChild variant="outlinePrimary" className="w-fit">
            <a
              href={`https://www.post.lt/siuntu-sekimas?parcels=${order.parcel_track}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Track shipment
            </a>
          </Button>
        ) : (
          <Button variant="outlinePrimary" className="w-fit" disabled>
            Track shipment
          </Button>
        ))}
    </div>
  );
}
